import { useEffect, useState } from "react";
import type { SlotProps } from "../../../core/platform/registry/registry";
import { useAuth } from "../../../core/platform/auth/AuthProvider";
import { refreshLoyaltyReplica } from "../data/replica";
import { LoyaltyAdmin } from "./LoyaltyAdmin";

/**
 * The till-header "Cards" button, and the replica refresh behind it.
 *
 * THE REFRESH RUNS FOR EVERYONE, as inventory's does: a cashier never sees the
 * button, but the till they ring on still needs to know which cards exist and
 * what each holds. Every minute, and offline it simply keeps the copy it has.
 */

const REFRESH_MS = 60_000;

export function LoyaltyButton({ token }: SlotProps) {
  const { can } = useAuth();
  const sessionToken = typeof token === "string" ? token : null;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionToken) return;
    const refresh = () => void refreshLoyaltyReplica(sessionToken).catch(() => false);
    refresh();
    const timer = setInterval(refresh, REFRESH_MS);
    return () => clearInterval(timer);
  }, [sessionToken]);

  if (!sessionToken || !can("loyalty.manage")) return null;

  return (
    <>
      <button type="button" className="terminal__signout" onClick={() => setOpen(true)}>
        Cards
      </button>
      {open && (
        <LoyaltyAdmin
          token={sessionToken}
          onClose={() => {
            setOpen(false);
            void refreshLoyaltyReplica(sessionToken).catch(() => false);
          }}
        />
      )}
    </>
  );
}
